var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42Z",
    fill: "#E3E3E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42Z",
    fill: "url(#paint0_radial_5089_35209)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2426 13.9289C26.0237 13.1478 27.29 13.1478 28.0711 13.9289C28.8521 14.7099 28.8521 15.9762 28.0711 16.7573L16.7574 28.071C15.9763 28.852 14.71 28.852 13.9289 28.071C13.1479 27.2899 13.1479 26.0236 13.9289 25.2426L25.2426 13.9289Z",
    fill: "#481EA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9288 16.7575C13.1478 15.9764 13.1478 14.7101 13.9288 13.929C14.7098 13.148 15.9762 13.148 16.7572 13.929L28.0709 25.2428C28.852 26.0238 28.852 27.2901 28.0709 28.0712C27.2899 28.8522 26.0236 28.8522 25.2425 28.0712L13.9288 16.7575Z",
    fill: "#481EA0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5089_35209",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21 22) rotate(139.686) scale(21.6391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c54ef03fe9261ac4d7533b5f6d14e255.svg";
export { ForwardRef as ReactComponent };